import {
    ApplicationConfig,
    importProvidersFrom,
    provideZoneChangeDetection,
} from '@angular/core';
import { provideRouter } from '@angular/router';

import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { provideAnimations, provideNoopAnimations } from '@angular/platform-browser/animations';
import {
    HttpClient,
    provideHttpClient,
    withInterceptors,
} from '@angular/common/http';
import { TranslateModule, TranslateLoader } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { Overlay, BlockScrollStrategy } from '@angular/cdk/overlay';
import { MAT_SELECT_SCROLL_STRATEGY } from '@angular/material/select';
import { routes } from './app-routing.module';
import { authInterceptor } from './core/auth-interceptor';
import { tokenInterceptor } from './core/token-interceptor';
import { FormlyModule } from '@ngx-formly/core';
import { MarkdownModule } from 'ngx-markdown';
import { ToastrModule } from 'ngx-toastr';
import { FormlyFieldAgGrid } from './formlyFormcontrols/formlyFieldTypes/ag-grid';
import { FormlyFieldButton } from './formlyFormcontrols/formlyFieldTypes/button';
import { FormlyFieldFile } from './formlyFormcontrols/formlyFieldTypes/fileField';
import { GridTypeComponent } from './formlyFormcontrols/formlyFieldTypes/grid.type';
import { CustomMultiSelectComponent } from './formlyFormcontrols/formlyFieldTypes/multi-select';
import { CustomQuillEditorComponent } from './formlyFormcontrols/formlyFieldTypes/quill-editor';
import { RepeatTypeComponent } from './formlyFormcontrols/formlyFieldTypes/repeat';
import { FormlyFieldStepper } from './formlyFormcontrols/formlyFieldTypes/stepper.type';
import { FormlyFieldTabs } from './formlyFormcontrols/formlyFieldTypes/tabs';
import { ViewUploadedFileComponent } from './formlyFormcontrols/formlyFieldTypes/view-uploaded-file';
import { DateRangeWrapper } from './formlyFormcontrols/wrappers/date-range-wrapper';
import { PanelFieldWrapper } from './formlyFormcontrols/wrappers/formly-wrapper';
import { MatChipWrapper } from './formlyFormcontrols/wrappers/mat-chip-wrapper';
import { MultipleFileUploadWrapper } from './formlyFormcontrols/wrappers/multi-file-upload-wrapper';
import { CommonLabelWrapperComponent } from './formlyFormcontrols/wrappers/phone-number.wrapper';
import { TooltipIconWrapperComponent } from './formlyFormcontrols/wrappers/tooltip.wrapper';
import { provideNativeDateAdapter } from '@angular/material/core';
import { provideMomentDateAdapter } from '@angular/material-moment-adapter';
import { CreateAccordionWrapper } from './formlyFormcontrols/wrappers/create-accordion';
import { Loader } from '@googlemaps/js-api-loader';
import { environment } from 'src/environments/environment';

export function scrollFactory(overlay: Overlay): () => BlockScrollStrategy {
    return () => overlay.scrollStrategies.block();
}
export function HttpLoaderFactory(http: HttpClient) {
    return new TranslateHttpLoader(http, './assets/i18n/', '.json');
}
export const appConfig: ApplicationConfig = {
    providers: [
        provideZoneChangeDetection({ eventCoalescing: true }),
        provideRouter(routes),
        provideAnimationsAsync(),
        provideAnimations(),
        provideNoopAnimations(),
        provideNativeDateAdapter(), 
        provideMomentDateAdapter(),
        provideHttpClient(withInterceptors([authInterceptor, tokenInterceptor])),
        importProvidersFrom(
            TranslateModule.forRoot({
                loader: {
                    provide: TranslateLoader,
                    useFactory: HttpLoaderFactory,
                    deps: [HttpClient],
                },
            }),
           
            MarkdownModule.forRoot(),
            ToastrModule.forRoot({
            positionClass: 'toast-top-right',  // Set position to top-right
              preventDuplicates: true,          // Optional: prevent duplicate messages
              timeOut: 3000,                    // Optional: time out for messages
             }),
             FormlyModule.forRoot({
                validationMessages: [
                  { name: 'required', message: 'This field is required' },
                ],
                types: [
                  { name: 'grid', component: GridTypeComponent },
                  { name: 'stepper', component: FormlyFieldStepper },
                  { name: 'agGrid', component: FormlyFieldAgGrid },
                  { name: 'file', component: FormlyFieldFile },
                  {
                    name: 'button',
                    component: FormlyFieldButton,
                    wrappers: ['form-field'],
                    defaultOptions: {
                      props: {
                        btnType: 'default',
                        type: 'button',
                      },
                    }
                  },
                  { name: 'tabs', component: FormlyFieldTabs },
                  { name: 'repeat', component: RepeatTypeComponent },
                  { name: 'quill-editor', component: CustomQuillEditorComponent },
                  { name: 'multi-select', component: CustomMultiSelectComponent },
                  { name: 'view-upload-file', component: ViewUploadedFileComponent }
                ],
                wrappers: [
                  { name: 'panel', component: PanelFieldWrapper },
                  { name: 'date-controls', component: DateRangeWrapper },
                  { name: 'mat-chip', component: MatChipWrapper },
                  { name: 'multi-file-upload', component: MultipleFileUploadWrapper },
                  { name: 'tooltip-icon', component: TooltipIconWrapperComponent },
                  { name: 'phone-number', component: CommonLabelWrapperComponent },
                  { name: 'create-accordion', component: CreateAccordionWrapper },
          
                ],
              }),
        ),
        {
          provide: Loader,
          useValue: new Loader({
            apiKey: environment.googleMapKey,
            libraries: ['places'],
          }),
        },
        { provide: MAT_SELECT_SCROLL_STRATEGY, useFactory: scrollFactory, deps: [Overlay] }
    ],
};
function provideDateFnsAdapter(): import("@angular/core").Provider | import("@angular/core").EnvironmentProviders {
    throw new Error('Function not implemented.');
}

